import React, { useEffect, useState } from "react";
import CustomHeader from "../../components/header/index.jsx";
import PageHeader from "../../components/pageHeader";
import './aidashboard.scss';
import { Container, Col, Row } from 'react-bootstrap';
import * as moment from "moment"
import { useNavigate, useLocation } from 'react-router-dom';
import url from "../../config.js"
import MultiCard from '../../components/multiCard/index.jsx';
import { ProjectCreationComponent } from '../../components/chatComponent';
import EmptyState from '../../components/emptyState/index.jsx';

const domain = url.domain;

function AiDashboard() {
  const navigate = useNavigate()
  const query = new URLSearchParams(useLocation().search);
  const agent = query.get('agent');
  const projectArchetype = (agent === 'Migration') ? 'migration-template' : (agent === 'Integration') ? 'integration-template' : 'design-template';

  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');

  const [state, setState] = useState({
    projects: [],
    showModal: false,
    projectArchetype: projectArchetype,
    activeTeckStackIndex: '',
    projectName: '',
    projectType: 'mule',
    cloudType: 'not-mentioned',
    validationClass: ''
  })

  const submit = () => {
    if (!state.projectName || state.projectName === '') {
      setState(prevState => ({ ...prevState, validationClass: 'validation-error' }))
    } else {
      console.log("STATE", state);
      var postObj = {
        "cloudType": state.cloudType,
        "createdOn": moment().format("DD-MM-YYYY hh:mm:ss"),
        "projectName": state.projectName,
        "projectType": state.projectType,
        "projectArchetype": state.projectArchetype,
        "processType": 'single'
      }

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-access-token': localStorage.getItem('token') },
        body: JSON.stringify(postObj)
      };
      fetch(domain + '/api/v1/project', requestOptions)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          getProject();
        });
    }
  }

  const deleteProject = async (project_id) => {
    try {
      // Call your backend API to delete
      const response = await fetch(`${domain}/api/v1/project/${project_id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        }
      });

      const result = await response.json();
      console.log('Delete response:', result);

      if (result.deleteProject.success) {
        // Remove from state
        setState(prevState => ({
          ...prevState,
          projects: prevState.projects.filter(p => p._id !== project_id)
        }));
        alert('Project deleted successfully!');
      } else {
        alert('Failed to delete project: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting project:', error);
      alert('Error deleting project');
    }
  };

  function getProject() {
    const requestOptions = {
      method: 'GET',
      headers: { 'x-access-token': localStorage.getItem('token') }
    };
    fetch(domain + '/api/v1/project', requestOptions)
      .then(response => response.json())
      .then(data => {
        const projectList = Array.isArray(data.projects) ? data.projects : Array.isArray(data) ? data : [];
        if (projectList.length > 0) {
          setState(prevState => ({
            ...prevState,
            projects: projectList.filter(
              project => project.projectArchetype === projectArchetype
            )
          }));
        }
      });
  }

  const gotproject = (id, name, archeType) => {
    // Encode the name — a project name may contain "/", "#" or "?" (e.g.
    // "SAP Sheet/Unsheet Proposal"), which would inject extra path segments and
    // break the ":projName/:projId" route match, bouncing the user to login.
    const safeName = encodeURIComponent(name);
    if (archeType === 'integration-template') {
      navigate(`/AIAgentHub/integrationAgent/${safeName}/${id}`);
    } else if (archeType === 'design-template') {
      navigate(`/AIAgentHub/designAgent/${safeName}/${id}`);
    } else if (archeType === 'migration-template') {
      navigate(`/AIAgentHub/migrationAgent/${safeName}/${id}`);
    } else {
      navigate(`/projectDetails/${safeName}/${id}`);
    }
  }

  useEffect(() => {
    getProject()
  }, [])

  // Get agent display name
  const getAgentDisplayName = () => {
    switch (agent) {
      case 'Migration': return 'Migration Agent';
      case 'Integration': return 'Integration Agent';
      case 'Design': return 'Design Agent';
      default: return 'AI Agent Hub';
    }
  };

  // Filter projects
  const filteredProjects = state.projects.filter(project => {
    const matchesSearch = project.projectName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType === 'all' || project.projectType === filterType;
    return matchesSearch && matchesType;
  });

  return (
    <div className="root">
      <CustomHeader />
      <main className="content">
        <div className="dashboard-container">
          <Container fluid className="dashboard-content">
            <Row className="dashboard-row">
              {/* Main Content - Full Width */}
              <Col lg={12} className="main-column">
                {/* Header Section with Badge */}
                <div className="dashboard-header">
                  <PageHeader
                    badge="Dashboard"
                    title={getAgentDisplayName()}
                    subtitle="Browse your existing projects below or create new ones using the AI assistant"
                  />
                </div>

                {/* Filters Row */}
                {/* <div className="dashboard-toolbar">
                  <div className="search-filter-group">
                    <div className="search-wrapper">
                      <input
                        type="text"
                        placeholder="Search projects..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                      />
                    </div>
                    <select
                      className="filter-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="all">All Types</option>
                      <option value="mule">MuleSoft</option>
                      <option value="react">React</option>
                      <option value="spring">Spring Boot</option>
                    </select>
                  </div>
                  
                  <span className="results-count">
                    {filteredProjects.length} {filteredProjects.length === 1 ? 'project' : 'projects'}
                  </span>
                </div> */}

                {/* Projects Grid */}
                <div className="projects-grid-container">
                  <div className="projects-grid">
                    {filteredProjects && filteredProjects.length >= 1 ? (
                      filteredProjects.map((project) => {
                        // FIXED: Correct data structure
                        const headerData = {
                          [project.projectType]: project.projectName
                        };
                        
                        const footerData = {
                          'Cloud': project.cloudType || 'not-mentioned',
                          'Created': moment(project.createdAt).format('MMM D, YYYY')
                        };
                        
                        return (
                          // <MultiCard 
                          //   key={project._id}
                          //   headerData={headerData} 
                          //   footerData={footerData} 
                          //   theme="dark" 
                          //   onClick={() => gotproject(project._id, project.projectName, project.projectArchetype)} 
                          // />
                           <MultiCard
                              key={project._id}
                              headerData={headerData}
                              footerData={footerData}
                              theme="dark"
                              onClick={() => gotproject(project._id, project.projectName, project.projectArchetype)}
                              // onEdit={(headerData, footerData) => {
                              //   console.log('Edit clicked:', headerData, footerData);
                              //   setEditingProject({ ...headerData, ...footerData });
                              //   setShowEditModal(true);
                              // }}
                              onDelete={(headerData, footerData) => {
                                console.log('Delete clicked:', project);
                                const projectName = Object.values(headerData)[0];

                                if (window.confirm(`Are you sure you want to delete "${projectName}"?`)) {
                                  deleteProject(project._id);
                                }
                              }}
                            />
                        )
                      })
                    ) : (
                       <EmptyState
                          title="No Projects Found"
                          description={searchTerm ? 'Try a different search term' : 'Create your first project to get started'}
                          icon="folder"
                        />
                    )}
                  </div>
                </div>
              </Col>
            </Row>

            {/* Floating Chat Button - Bottom Right */}
            {/* <div className="chat-fab-wrapper">
              <ProjectCreationComponent 
                onFieldUpdate={(field, value) => {
                  setState(prev => ({ ...prev, [field]: value }));
                }} 
                submit={submit} 
              />
            </div> */}
          </Container>
        </div>
      </main>
    </div>
  );
}

export default AiDashboard;